import { find } from 'lodash';
import cx from 'classnames';

import {
  defaultScaleSize,
  shapeList,
  sizeList,
  smileyFacesList,
} from 'sharedParts/config/blockConfig/questionScale';
import { isShapeSmile } from 'sharedParts/utils/validateScaleShapeType';
import personalLabelMap from 'sharedParts/config/personalLabelMap';

import { faCircle as solidCircleIcon } from '@fortawesome/pro-solid-svg-icons';

import RatingItemIcons from '../rating/RatingItemIcons';

const getRenderedScaleIcons = ({
  e2e,
  shape,
  color,
  enableFillColor,
  width,
  size = defaultScaleSize,
  personalLabelType,
  itemListCount,
  emptySubstrate = {},
  fullSubstrate = {},
  empty = {},
  full = {},
}) => {
  const iconSize = find(sizeList, { value: size }).size;
  const iconStyle = {
    fontSize: `${iconSize}px`,
    width,
  };

  if (isShapeSmile(shape)) {
    const iconsList = [...smileyFacesList[itemListCount]];
    if (personalLabelType && personalLabelType === personalLabelMap.numberDesc) iconsList.reverse();
    const emptyIcons = iconsList.map((icons) => {
      return RatingItemIcons({
        substrateStyle: iconStyle,
        iconStyle,
        substrateClassName: emptySubstrate.className,
        iconClassName: empty.className,
        substrateIcon: icons['full'],
        icon: icons['empty'],
        onClick: empty.onClick,
        e2e,
        shape,
        enableFillColor,
      });
    });

    const fullIcons = iconsList.map((icons) => {
      return RatingItemIcons({
        substrateStyle: { ...iconStyle, color: 'white' },
        iconStyle: { ...iconStyle, color },
        substrateClassName: fullSubstrate.className,
        iconClassName: full.className,
        substrateIcon: solidCircleIcon,
        icon: icons['full'],
        onClick: full.onClick,
        shape,
        enableFillColor,
      });
    });

    return { empty: emptyIcons, full: fullIcons };
  }

  const currentShapeClassList = find(shapeList, { value: shape }).classNameList;

  return {
    empty: RatingItemIcons({
      substrateStyle: iconStyle,
      iconStyle,
      substrateClassName: cx(emptySubstrate.className, currentShapeClassList['full']),
      iconClassName: cx(empty.className, currentShapeClassList['empty']),
      onClick: empty.onClick,
      e2e,
      shape,
      enableFillColor,
    }),
    full: RatingItemIcons({
      substrateStyle: iconStyle,
      iconStyle: { ...iconStyle, color },
      substrateClassName: cx(fullSubstrate.className, currentShapeClassList['fullSubstrate']),
      iconClassName: cx(full.className, currentShapeClassList['full']),
      onClick: full.onClick,
      shape,
      enableFillColor,
    }),
  };
};

export default getRenderedScaleIcons;
